<div class="edit-organization-container" style="min-width: 380px; margin-right: auto; box-shadow: none; border-radius: 0; background: none;">
  <div class="card shadow-sm rounded-4 border-0">
    <div class="card-body p-4">
      <!-- Success message -->
      <div *ngIf="updateSuccess" class="alert alert-success col-md-7" role="alert" data-testid="success-alert">
        Organization updated successfully.
      </div>
      
      <!-- Error message -->
      <div *ngIf="serverError" class="alert alert-danger col-md-7" role="alert" data-testid="error-alert">
        {{ serverError?.message || 'A server error occurred. Please try again later.' }}
      </div>

      <!-- Loading indicator -->
      <div *ngIf="isLoading" class="loading-container">
        <p>Loading organization data...</p>
      </div>

      <!-- Edit form -->
      <form [formGroup]="editForm" (ngSubmit)="onSubmit()" style="max-width: 940px;" class="customer-form" data-testid="edit-organization-form" *ngIf="!isLoading">
        <div class="mb-3 mt-3">
          <label for="companyType" class="form-label">Company Type <span class="text-danger">*</span></label>
          <select id="companyType" class="form-select fancy-select" formControlName="companyType" required data-testid="company-type-dropdown">
            <option value="">Select company type</option>
            <option *ngFor="let type of types" [value]="type.orgTypeId">{{ type.orgTypeName }}</option>
          </select>
          <div class="text-danger mt-1" *ngIf="editForm.get('companyType')?.invalid && editForm.get('companyType')?.touched">
            Please select a company type.
          </div>
        </div>

        <div class="mb-3">
          <label for="name" class="form-label">Organization Name<span class="text-danger">*</span></label>
          <input
            id="name"
            class="form-control"
            [ngClass]="{'is-invalid': editForm.get('name')?.invalid && editForm.get('name')?.touched}"
            formControlName="name"
            placeholder="Organization Name"
            required
            data-testid="organization-name-field"
          />
          <div class="invalid-feedback d-block" *ngIf="editForm.get('name')?.invalid && editForm.get('name')?.touched">
            Organization name is a mandatory field.
          </div>
        </div>

        <div class="mb-3">
          <label for="displayName" class="form-label">Display name</label>
          <input id="displayName" class="form-control" formControlName="displayName" placeholder="Display name" data-testid="organization-displayname-field" />
        </div>

        <div class="row g-2 mb-2">
          <div class="col">
            <label for="soldTo" class="form-label">Sold To</label>
            <input id="soldTo" class="form-control" formControlName="soldTo" placeholder="Sold To" data-testid="sold-to-field" />
          </div>
          <div class="col-md-6">
            <label for="shipTo" class="form-label">Ship To</label>
            <input id="shipTo" class="form-control" formControlName="shipTo" placeholder="Ship To" data-testid="ship-to-field" />
          </div>
        </div>

        <div class="row g-2 mb-2">
          <div class="col">
            <label for="address1" class="form-label">Address 1</label>
            <input id="address1" class="form-control" formControlName="address1" placeholder="Address Line 1" />
          </div>
          <div class="col-md-6">
            <label for="address2" class="form-label">Address 2</label>
            <input id="address2" class="form-control" formControlName="address2" placeholder="Address Line 2" />
          </div>
        </div>

        <div class="row g-2 mb-2">
          <div class="col">
            <label for="city" class="form-label">City</label>
            <input id="city" class="form-control" formControlName="city" placeholder="City" />
          </div>
          <div class="col-md-3">
            <label for="state" class="form-label">State</label>
            <input id="state" class="form-control" formControlName="state" placeholder="State" />
          </div>
          <div class="col-md-3">
            <label for="postalCode" class="form-label">Postal Code</label>
            <input id="postalCode" class="form-control" formControlName="postalCode" placeholder="Postal Code" />
          </div>
        </div>

        <div class="row g-2 mb-2">
          <div class="col">
            <label for="country" class="form-label">Country</label>
            <input id="country" class="form-control" formControlName="country" placeholder="Country" />
          </div>
          <div class="col-md-6">
            <label for="phone" class="form-label">Phone</label>
            <input id="phone" class="form-control" formControlName="phone" placeholder="Phone Number" />
          </div>
        </div>

        <div class="row g-2 mb-2">
          <div class="col">
            <label for="firstName" class="form-label">Contact First Name</label>
            <input id="firstName" class="form-control" formControlName="firstName" placeholder="First Name" />
          </div>
          <div class="col-md-6">
            <label for="lastName" class="form-label">Contact Last Name</label>
            <input id="lastName" class="form-control" formControlName="lastName" placeholder="Last Name" />
          </div>
        </div>

        <div class="mb-3">
          <label for="pointOfContactDetails" class="form-label">Point of Contact Details</label>
          <textarea id="pointOfContactDetails" class="form-control" formControlName="pointOfContactDetails" placeholder="Additional contact details" rows="2"></textarea>
        </div>

        <div class="form-check mb-2">
          <input type="checkbox" class="form-check-input" id="excludeReferrals" formControlName="excludeReferrals" style="transform: scale(1.1); margin-right: 6px;" />
          <label class="form-check-label fs-6" for="excludeReferrals">Exclude Referrals</label>
        </div>

        <div class="form-check mb-2">
          <input type="checkbox" class="form-check-input" id="active" formControlName="active" style="transform: scale(1.1); margin-right: 6px;" />
          <label class="form-check-label fs-6" for="active">Active</label>
        </div>

        <div class="d-flex gap-3 mt-3">
          <button type="button" class="btn btn-outline-secondary flex-fill py-3" (click)="onCancel()" [disabled]="isLoading">
            <i class="fas fa-arrow-left me-1"></i> Go Back
          </button>
          <button type="submit" class="btn btn-gradient flex-fill py-3" data-testid="update-organization-btn" [disabled]="isLoading || !hasFormChanges || editForm.invalid">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isLoading ? 'Updating...' : 'Update Organization' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>